import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Users|Details|`;

export type SpUserDetailsLocs = 'SpUserDetailsLabelCandidateRestrictType';

export const spUserDetailsLocs: LocDefs<SpUserDetailsLocs> = {
	SpUserDetailsLabelCandidateRestrictType: {
		defaultValue: 'Candidate Restrict Type',
		description: 'Label for the candidate restrict type field.',
		displayPath: `${dpRoot}|Candidate Restrict Type`,
		displayType: 'Label',
		htmlAllowed: false,
		feature: HubFeature.Core,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SpUserDetailsLocs>(spUserDetailsLocs);
export type SPUserDetailsLocType = LocMap<SpUserDetailsLocs>;
